// import { outLogin } from '@/services/logic/login';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { createStyles } from 'antd-style';
// import { stringify } from 'querystring';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React, { useCallback } from 'react';
import { flushSync } from 'react-dom';
import { BroadcastSync } from 'react-simple-channel';
import { LOGIN_STATUS_CHANNEL } from '@/constants/broadcast-channel';
import { LOGIN_STATUS } from '@/utils/enums';

import HeaderDropdown from '../HeaderDropdown';
import QdLoading from '@/components/Common/QdLoading';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'grid',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
    avatarName: {
      // color: 'white',
      fontWeight: '500',
    },
  };
});

export const AvatarName = () => {
  const { styles } = useStyles();
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  const { name } = currentUser || {};

  return <span className={styles.avatarName}>{name}</span>;
};

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ children }) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  // const loginOut = async () => {
  //   await outLogin();
  //   const { search, pathname } = window.location;
  //   const urlParams = new URL(window.location.href).searchParams;
  //   /** 此方法会跳转到 redirect 参数所在的位置 */
  //   const redirect = urlParams.get('redirect');
  //   // Note: There may be security issues, please note
  //   if (window.location.pathname !== '/user/login' && !redirect) {
  //     history.replace({
  //       pathname: '/user/login',
  //       search: stringify({
  //         redirect: pathname + search,
  //       }),
  //     });
  //   }
  // };
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');

  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event;
      if (key === 'logout') {
        flushSync(() => {
          setInitialState((s) => ({ ...s, currentUser: undefined }));
        });
        // 退出登录，通知其他 tab 页更新登录状态
        BroadcastSync.query(LOGIN_STATUS_CHANNEL).post(LOGIN_STATUS.LOGOUT);
        return;
      }
      if (key === 'personalinfo') {
        history.push('/layouts/personalinfo');
        return;
      }
      history.push(`/account/${key}`);
    },
    [setInitialState],
  );

  const loading = (
    <span className={styles.action}>
      <QdLoading
        loading={true}
        size={28}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems = [
    // 个人资料设置
    {
      key: 'personalinfo',
      icon: <UserOutlined />,
      label: '个人资料设置',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  return (
    <HeaderDropdown
      className='qd-mx-auto'
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      {children}
    </HeaderDropdown>
  );
};
